export const IMAGES = {
  heroPortrait: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85",
  speakingWorkshop: "https://images.unsplash.com/photo-1544531586-fde5298cdd40?crop=entropy&cs=srgb&fm=jpg&q=85",
  boardroom: "https://images.unsplash.com/photo-1758691736722-cda1858056e0?crop=entropy&cs=srgb&fm=jpg&q=85",
  bookMockup: "https://images.unsplash.com/photo-1543002588-bfa74002ed7e?crop=entropy&cs=srgb&fm=jpg&q=85",
  audienceStage: "https://images.unsplash.com/photo-1627931539006-d5c4677e05ea?crop=entropy&cs=srgb&fm=jpg&q=85",
  journalReading: "https://images.unsplash.com/photo-1483546363825-7ebf25fb7513?crop=entropy&cs=srgb&fm=jpg&q=85",
  avatars: [
    "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1559223694-98ed5e272fef?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
};
